import isInternalUrl from '@docusaurus/isInternalUrl';
import Link from '@docusaurus/Link';
import useBaseUrl from '@docusaurus/useBaseUrl';
import clsx from 'clsx';
import React from 'react';

interface FooterLinkItemProps {
  item: {
    to?: string;
    href?: string;
    label: string;
    prependBaseUrlToHref?: boolean;
    className?: string;
    [key: string]: unknown;
  };
}

export function FooterLinkItem({ item }: FooterLinkItemProps) {
  const { to, href, label, prependBaseUrlToHref, className, ...rest } = item;
  const toUrl = useBaseUrl(to);
  const normalizedHref = useBaseUrl(href, { forcePrependBaseUrl: true });

  return (
    <Link
      className={clsx('inline-flex items-center text-sm leading-5 text-text hover:text-subtle', className)}
      {...(href ? { href: prependBaseUrlToHref ? normalizedHref : href } : { to: toUrl })}
      {...rest}
    >
      {label}
      {href && !isInternalUrl(href) && <span className="ml-1">↗</span>}
    </Link>
  );
}
